module.exports = __webpack_public_path__ + "static/media/modelo-d.9b8ddddb.png";